// Shared footer for the marketing pages. Midnight ground, lockup with the
// tagline, sentence-case links. Legal pages are static HTML, linked directly.
import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Brand/BrandLogo';
import { MARKETING_LINKS } from './MarketingNav';

const MarketingFooter = () => (
  <footer className="bg-midnight text-white/70 py-12">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div className="-ml-3">
          <Logo variant="onBlue" size="md" tagline />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-12 gap-y-3 text-sm">
          <nav className="flex flex-col gap-2" aria-label="Pages">
            {MARKETING_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="hover:text-white transition-colors">{l.label}</Link>
            ))}
          </nav>
          <nav className="flex flex-col gap-2" aria-label="Account">
            <Link to="/login" className="hover:text-white transition-colors">Sign in</Link>
            <a href="/waitlist.html" className="hover:text-white transition-colors">Join the waitlist</a>
          </nav>
          <nav className="flex flex-col gap-2" aria-label="Legal">
            <a href="/privacy-policy.html" className="hover:text-white transition-colors">Privacy policy</a>
            <a href="/terms-of-service.html" className="hover:text-white transition-colors">Terms of service</a>
            <a href="/data-processing-agreement.html" className="hover:text-white transition-colors">Data processing</a>
          </nav>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 text-sm">
        <span>&copy; {new Date().getFullYear()} Finance Forecaster</span>
        <span>Read-only bank connections through Plaid. Nothing is shared with your partner until you choose.</span>
      </div>
    </div>
  </footer>
);

export default MarketingFooter;
